module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-cb6d0b2e51a61a443732eb4f4d1c1fe0.svg";